import { render, staticRenderFns } from "./pwd-form.vue?vue&type=template&id=5055a73c&scoped=true"
import script from "./pwd-form.vue?vue&type=script&lang=js"
export * from "./pwd-form.vue?vue&type=script&lang=js"
import style0 from "./pwd-form.vue?vue&type=style&index=0&id=5055a73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055a73c",
  null
  
)

export default component.exports